
export default {
    "de": {
        "components": {
            "controls": {
                "common": {
                    "search": "Suche nach Aufträgen",
                    "today": "Heute",
                    "filter": {
                        "open": "Anfragen",
                        "unfinished": "Unterbrochen"
                    }
                }
            },

            "list": {
                "assembling": {
                    "buttons": {
                        "start": "Montageauftrag",
                        "proceed": "Montage fortsetzen"
                    }
                },

                "servicing": {
                    "buttons": {
                        "start": "Serviceauftrag",
                        "proceed": "Serviceauftrag fortsetzen"
                    }
                }
            },

            "messages": {
                "common": {
                    "labels": {
                        "reason": "Grund:",
                        "requests": "Anfrage von {name} für:"
                    }
                }
            }
        },

        "views": {
            "detail": {
                "assembling": {
                    "labels": {
                        "instruction": "Montageanleitung"
                    }
                },
                "servicing": {
                    "labels": {
                        "instruction": "Serviceanleitung"
                    }
                }
            }
        },

        "windows": {
            "request_respond": {
                "common": {
                    "valid_until_prefix": "Annahmefrist endet",
                
                    "labels": {
                        "message": "Nachricht:",
                        "message_from": "Nachricht von",
                        "reason": "Grund wählen:"
                    },

                    "reasons": {
                        "date_conflict": "Terminkonflikt"
                    }
                },
                "assembling": {
                    "title": "Montageanfrage beantworten"
                },
                "servicing": {
                    "title": "Serviceanfrage beantworten"
                }
            },

            "cancel_reason": {
                "common": {
                    "phrases": {
                        "intro_2": "Bitte wählen Sie den Grund dafür aus und erfassen Sie eine Mitteilung für den Projektleiter."
                    },

                    "labels": {
                        "message": "Mitteilung an den Projektleiter",
                        "trigger_service": "Reparaturauftrag anstoßen"
                    },

                    "placeholder": {
                        "message": "Beschreiben Sie das Problem, den Schaden oder das Bild"
                    }
                },
                "assembling": {
                    "title": "Montage {mode}",

                    "phrases": {
                        "intro_1": "Sie möchten den Montageauftrag <strong>{mode}</strong>."
                    },

                    "buttons": {
                        "perform": "Montage {mode}"
                    }
                },
                "servicing": {
                    "title": "Serviceauftrag {mode}",

                    "phrases": {
                        "intro_1": "Sie möchten den Serviceauftrag <strong>{mode}</strong>."
                    },

                    "buttons": {
                        "perform": "Serviceauftrag {mode}"
                    }
                }
            }
        }
    }
}